import { render, staticRenderFns } from "./Makeup.vue?vue&type=template&id=b2a152b0"
import script from "./Makeup.vue?vue&type=script&lang=js"
export * from "./Makeup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports